import { render, staticRenderFns } from "./product-solar-sentry.vue?vue&type=template&id=4c8572e6&scoped=true"
import script from "./product-solar-sentry.vue?vue&type=script&lang=js"
export * from "./product-solar-sentry.vue?vue&type=script&lang=js"
import style0 from "./product-solar-sentry.vue?vue&type=style&index=0&id=4c8572e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8572e6",
  null
  
)

export default component.exports